const L4PlanDate = (initiative) => {
    if (!initiative || !initiative.timeline || !Array.isArray(initiative.timeline)) {
      return null;
    }
    const l1Entry = initiative.timeline.find((entry) => entry.stage === 'L4');
    if(!new Date(l1Entry.date.plan)){
        return null;
    }
    return new Date(l1Entry.date.plan);
  };
  
  export default L4PlanDate;
  